export default "__VITE_ASSET__Ch5D8pib__"